import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import classname from 'classnames'
import { updateTab, updatePopup, updatePopupTab } from '../../../actions/editordashboard.js'
import {  getAdminSubmission,  updateAdminSubmissionInput,  adminGetDocuments } from '../../../actions/Admin'
import moment from 'moment'
import TopNav from '../../includes/TopNav.js';
import Pager from '../Pager.js';
import AdminDashboardMenu from './AdminDashboardMenu';
import {getFormattedTime, docStatusToString} from '../../../util/displayUtils.js';
import AdminDocumentsTable from './AdminDocumentsTable';
import {Helmet} from "react-helmet";
import {getUserSession} from '../../../actions/user.js';

//This is the real one simon
class AdminSubmissions extends Component {
  constructor(props) {
    super(props);
    this.getUserSession();
  }
  getUserSession(){
    console.log('getting user session');
    this.props.dispatch(getUserSession(ret => {
      if(ret !== false && ret.user.role !== 'admin') {
        window.location.href = "/login";
      } else if(ret === false) {
        window.location.href = "/login";
      }
    }));
  }
  componentDidMount(){
    if(this.props.Admin.submissionForm.status && this.props.Admin.submissionForm.page) {
      // figure out when this is supposed to be sent out
      this.props.dispatch(getAdminSubmission(this.props.Admin.submissionForm.status, this.props.Admin.submissionForm.page, () => { } ))
    }
    this.checkForUpdates();
    this.adminGetDocuments();
  }
  adminGetDocuments(){
    this.props.dispatch(adminGetDocuments());
  }
  changeSubmissionsFilter(e) {
    var statusValue = e.target.value;
    if(statusValue.indexOf(',') > 0) {
      statusValue = statusValue.split(',');
    }
    this.props.dispatch(adminGetDocuments(1, statusValue));
  }
  componentWillUpdate(props){
    if( this.props.User && this.props.User.fetched ) { // only after session fetched
      if( this.props.User.role != "admin" || !this.props.User.loggedin) {
        
      }
    }
  }
  checkForUpdates(){
      // setTimeout(function() {
      //   this.props.dispatch(getAdminSubmission(this.props.Admin.submissionForm.status, this.props.Admin.submissionForm.page, () => { } ))
      //   this.checkForUpdates()
      //   console.log("Checking for updates!")
      // }.bind(this), 3000);
  }
  updateAdminSubmissionInput(key, e){
      console.log(key);
      console.log(e);
      console.log(e.target.getAttribute('value'));
      this.props.dispatch(updateAdminSubmissionInput(key, e.target.getAttribute('value')))
      this.props.dispatch(getAdminSubmission(this.props.Admin.submissionForm.status, this.props.Admin.submissionForm.page, () => { } ))
  }
  updatePopup(state){
      this.props.dispatch(updatePopup(state))
  }
  getNextPage(page) {
    this.props.dispatch(adminGetDocuments(page, this.props.Admin.currentStatusFilter));
  }
  render(){
    var o1 = classname({
      text_header: true,
      easing: true,
      active: !this.props.Admin.submissionForm.status
    })

    var o2 = classname({
      text_header: true,
      easing: true,
      active: this.props.Admin.submissionForm.status == 0
    })

    var o3 = classname({
      text_header: true,
      easing: true,
      active: this.props.Admin.submissionForm.status == 1
    })

    var o4 = classname({
      text_header: true,
      easing: true,
      active: this.props.Admin.submissionForm.status == 2
    })

    var o5 = classname({
      text_header: true,
      easing: true,
      active: this.props.Admin.submissionForm.status == 3
    })

    var o6 = classname({
      text_header: true,
      easing: true,
      active: this.props.Admin.submissionForm.status == 4
    })

    return(
      <div>
        <Helmet>
          <meta name="viewport" content="width=1280, initial-scale=minimum-scale" />
        </Helmet>
        <TopNav />
        <br/><br/>
        <section className="admin-container">
          <AdminDashboardMenu/>
          {/* filter options */}
          <div className="adminDashboardTabTitle">Papers</div>
          <div>
            <select onChange={this.changeSubmissionsFilter.bind(this)}>
              <option value="">All</option>
              <option value="0">{docStatusToString(0)}</option>
              <option value="1,2,3">Paid</option>
              <option value="1">{docStatusToString(1)}</option>
              <option value="2">{docStatusToString(2)}</option>
              <option value="3">{docStatusToString(3)}</option>
              <option value="4">{docStatusToString(4)}</option>
            </select>
          </div>
          <AdminDocumentsTable documents={this.props.Admin.submissions}></AdminDocumentsTable>
          <Pager key={this.props.Admin.currentStatusFilter} totalCount={this.props.Admin.totalSubmissions} currentPage="1" clickHandler={this.getNextPage.bind(this)} pageSize="20"></Pager>
        </section>
      </div>
    )
  }
}

export default connect( ({Admin}) => ({Admin}) ) (AdminSubmissions)

// <div className="admin-options-button">Invoices</div>
// <div className="options no-spacing">
//   <a className={o1} onClick={this.updateAdminSubmissionInput.bind(this, 'status')}>All Edits</a>
//   <a className={o2} onClick={this.updateAdminSubmissionInput.bind(this, 'status')} value="0">Unpaid</a>
//   <a className={o3} onClick={this.updateAdminSubmissionInput.bind(this, 'status')} value="1">Unedited</a>
//   <a className={o4} onClick={this.updateAdminSubmissionInput.bind(this, 'status')} value="2">In progress</a>
//   <a className={o5} onClick={this.updateAdminSubmissionInput.bind(this, 'status')} value="3">Edited</a>
//   <a className={o6} onClick={this.updateAdminSubmissionInput.bind(this, 'status')} value="4">Expired</a>
// </div>



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AdminSubmissions.js